import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";
import { minutesToHours } from "@/utils/timeSlotConverter";
import api from "@/services/api";

export const useCompanyStore = defineStore("company", () => {
  const company = useLocalStorage("company", {});
  const branch = ref({});
  const staffList = ref([]);
  const isEmptyTenant = ref(false);

  const isPrepayment = computed(() => {
    if (!branch.value) {
      return false;
    }
    return branch.value.paymentOnlineEnabled;

    // TODO: BMN-1043 remove the crutch later
    // return false;
  });

  const companyName = computed(() => company.value?.name || "");

  const companyIsHotel = computed(
    () => company.value?.crmMode === "hotel" ?? false,
  );

  const currencyName = computed(
    () => company.value?.currencyParams?.name ?? "",
  );

  const languages = computed(() => company.value?.languages ?? ["uk"]);
  const country = computed(() => company.value?.country ?? "UA");

  const pendingInvoicesCount = computed(
    () => Number(company.value?.pendingInvoicesCount) || 0,
  );

  function setBranch(data) {
    branch.value = data;
  }

  function getWorkingsHours(day = "") {
    let result = { start_time: 8, end_time: 20 };
    if (branch.value.workingHours) {
      if (!day) {
        const minDates = branch.value.workingHours.map((item) => item.from);
        let maxDates = branch.value.workingHours.map((item) => item.to);
        let maxDatesChanged = maxDates.map((item) => {
          if (item === 0) {
            return 24 * 60;
          }
          return item;
        });
        result.start_time = minutesToHours(Math.min(...minDates));
        result.end_time = minutesToHours(Math.max(...maxDatesChanged));
      } else {
        const dayHours = branch.value.workingHours.find(
          (item) => item.day === day,
        );
        if (dayHours) {
          result.start_time = minutesToHours(dayHours.from);
          result.end_time = minutesToHours(dayHours.to || 24 * 60);
        }
      }
    }

    return result;
  }

  function setStatusTenant(status) {
    isEmptyTenant.value = status;
  }

  async function fetchCompany() {
    try {
      const data = await api.company.show();
      company.value = data;
      return data;
    } catch (error) {
      console.error("Failed to fetch company:", error);
    }
  }

  async function fetchBranch() {
    try {
      const branches = await api.branches.list();
      if (branches?.[0]) {
        branch.value = branches[0];
      }
      return branch.value;
    } catch (error) {
      console.error("Failed to fetch branch:", error);
    }
  }

  function setCompany(data) {
    company.value = data;
  }

  function setStaffList(val) {
    staffList.value = val;
  }

  function $reset() {
    company.value = {};
    branch.value = {};
    staffList.value = [];
    isEmptyTenant.value = false;
  }

  return {
    branch,
    company,
    isEmptyTenant,
    isPrepayment,
    companyIsHotel,
    companyName,
    staffList,
    currencyName,
    languages,
    country,
    pendingInvoicesCount,
    setBranch,
    fetchBranch,
    fetchCompany,
    setCompany,
    setStatusTenant,
    getWorkingsHours,
    setStaffList,
    $reset,
  };
});
